/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Azione di consumo di un\'istanza articolo al POS
 */
export enum TipoConsumoArticolo {

    PRENOTAZIONE = 'PRENOTAZIONE',

    CONSEGNA = 'CONSEGNA'
}

